import React from "react";
import { useNavigate } from "react-router-dom";

// mui components
import { Stack } from "@mui/material";

// custom components
import CustomLayout from "../../components/layout";
import Heading3 from "../../components/typography/heading-03";
import UploadHistoryTable from "../../components/custom-table/upload-history-table";

// auth hook
import { useOrganizationId } from "../../features/auth/useOrganizationId";

// custom styles
import styles from "./index.module.scss";

const UploadHistory = () => {
	const navigate = useNavigate();
	
	// Ensure organization ID is set for TPO-ORG-ID header
	useOrganizationId('upload-history');

	const handleUploadHistoryRowClick = (item) => {
		const status = (item?.status || "").toLowerCase().trim();
		const hasPending = status.includes("pending");
		const isCreated = status.includes("created");
		const isSubmitted = status.includes("submitted");
		const isPendingApplicationSubmission = status.includes("pending application submission");
		// Treat any 'pending' status as not completed (except special case above)
		const isCompleted = !hasPending && (status.includes("completed") || isCreated || isSubmitted);

		// Pending Application Submission: navigate to edit-loan
		if (isPendingApplicationSubmission) {
			const guid =
				item?.loan_guid ||
				item?.loanGuid ||
				item?.loan_id ||
				item?.loanId ||
				item?.guid;
			if (guid) {
				navigate(`/edit-loan/${guid}`);
				return;
			}
		}

		if (isCompleted) {
			const guid =
				item?.loan_guid ||
				item?.loanGuid ||
				item?.loan_id ||
				item?.loanId ||
				item?.guid;
			if (guid) {
				navigate(`/loan-summary/${guid}`);
				return;
			}
			// If completed/created but GUID missing, route to pipeline as best-effort
			navigate("/pipeline");
			return;
		}

		// For pending items, go to New Loan and auto-open that upload in the flow
		navigate("/new-loan", {
			state: {
				fromUploadHistory: true,
				uploadHistoryItem: item,
			},
		});
	};

	const breadcrumb = [
		{ label: "Home", path: "/home" },
		{ label: "Upload History", path: "/upload-history" },
	];

	return (
		<CustomLayout breadcrumb={breadcrumb}>
			<div className={styles.container}>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					className={styles.tableTitleContainer}
				>
					<Heading3 text="Upload History" fontType="semibold" />
				</Stack>

				<Stack sx={{ mt: 3, mb: 3 }}>
					<UploadHistoryTable
						pageSize={25}
						isFullPage={true}
						onRowClick={handleUploadHistoryRowClick}
					/>
				</Stack>
			</div>
		</CustomLayout>
	);
};

export default UploadHistory;